import { observer } from 'mobx-react-lite'
import { OrgDto } from '@gap/backend/app-services/org/models/OrgDto'
import useStore from 'reusable/mobx-store-utils'
import { apiClientSilent } from 'api/trpc/trpc-client'
import Markdown from 'reusable/markdown/Markdown'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { LoadingModal } from 'reusable/mui/modals/LoadingModal'
import { namingConfig } from '@gap/utils/config/naming-config'

export interface DocViewPlanProps {
   client: Pick<OrgDto.entityWithNames, 'id' | 'logo' | 'name'>
   finalised: boolean
}

export default observer(function DocViewPlan({ client, finalised }: DocViewPlanProps) {
   const docViewPlanStore = useStore(() => ({
      markdown: null as null | string,
      fetch: async () => {
         docViewPlanStore.markdown = await apiClientSilent.doc.getLatestBusinessPlan.query({ clientOrgId: client.id, finalised })
      }
   }))
   useInitialMount(docViewPlanStore.fetch)

   if (!docViewPlanStore.markdown) {
      return <LoadingModal visible title={`Loading ${namingConfig.businessPlan.singular}...`} />
   }

   return <Markdown markdown={docViewPlanStore.markdown} id="doc-view-plan" readOnly={true} sx={{
      width: '100%',
      border: '1px solid #d1d5db',
   }} type={{ type: 'business-plan', meetingId: '' }} />
})